import React, { useMemo } from "react";
import Switch from "@mui/material/Switch";
import DataTable from "../_Components/DataTable";
import ApiFilesService from "../../../core/api/Api.filesService";
import _ from "lodash";
import SwalMessage from "../_Components/SwalMessage";
function DataGridFiles(props) {
  const changeSatusFile = async (id) => {
    try {
      let response = await ApiFilesService.changeActived({ id: id });
      if (response.succeeded == true) {
        document.getElementById("submitButton").click();
        SwalMessage({ title: response.message, iSsuccess: response.succeeded });
      }
    } catch (error) {
    }
  };
  const handleDownload = (item, typeFile, agentId, basketItemId, transactionId) => async (event) => {
    let obj = {
      id: agentId != null ? agentId : basketItemId != null ? basketItemId : transactionId != null ? transactionId : 0,
      fileName: item,
      access: 1,
      typeFile: typeFile,
    };
    await ApiFilesService.getFile(obj).then((response) => {
      const fileBlobUrl = URL.createObjectURL(new Blob([response]));
      const anchor = document.createElement("a");
      anchor.style.display = "none";
      anchor.id = item + Math.floor(Math.random() * 100);
      anchor.href = fileBlobUrl;
      anchor.download = item;
      document.body.appendChild(anchor);
      anchor.click();
    });
  };

  const columns = useMemo(() => [
    {
      accessor: "id",
      Header: "شماره",
      minWidth: 50,
    },
    {
      accessor: "filesTypeS",
      Header: "نوع فایل",
      minWidth: "100px",
    },
    {
      accessor: "fileName",
      Header: "نام فایل",
      minWidth: "100px",
    },
    {
      accessor: "createdPersianTime",
      Header: "تاریخ ایجاد",
      minWidth: "90px",
      maxWidth: "90px",
    },
    {
      accessor: "isDeleted",
      Header: "وضعیت فایل",
      minWidth: "100px",
      align: "center",
      Cell: ({ row }) => (
        <div className="text-center">
          <Switch
            checked={row.original.isActive}
            //checked={state.checkedA}
            value="row.original.isActive"
            color="primary"
            inputProps={{ "aria-label": "primary checkbox" }}
            onChange={() => changeSatusFile(row.original.id)}
          />
        </div>
      ),
    },
    {
      Header: "عملیات",
      accessor: "",
      minWidth: 150,
      align: "center",
      Cell: ({ row }) => (
        <div className="text-center">
          {/* نمایش */}
          {/* { <Link className="btn btn-light-primary btn-sm mr-2 btn-icon" to={`/promoCategoryAgent/${row.original.id}`}>
                            <i className='far fa-edit text-small'></i>
                        </Link> } */}

          <span
            className="btn btn-light-info "
            title="دانلود"
            onClick={handleDownload(
              row.original.fileName,
              row.original.fileAddress?.split("/")[3],
              row.original.agentId,
              row.original.basketItemId,
              row.original.transactionId,
            )}
            style={{ cursor: "pointer" }}
          >
            {" "}
            <i className="fas fa-download text-small"></i>
          </span>

          {/* حذف */}
          {/* <div className="btn btn-light-primary btn-sm mr-2 btn-icon">
                            <i className='far fa-trash-alt text-small'    onClick={() => { {checkBoxList.some((item)=>item.id==row.original.id) ?  
                                                    handleRemoveItem(checkBoxList,1):  handleRemoveItem(row.original,0)}}}>                                                        
                                                    </i>
                            </div> */}
        </div>
      ),
    },
  ]);

  const config = {
    page_size: 10,
    length_menu: [10, 20, 50, 100],
    show_filter: false,
    show_pagination: true,
    pagination: "advance",
    button: {
      excel: false,
      print: false,
    },
    language: {
      length_menu: " _MENU_  رکورد در هر صفحه",
      filter: "جستجو ...",
      info: " _START_ - _END_ از _TOTAL_ رکورد",
      pagination: {
        first: "First",
        previous: <i className="fa fa-chevron-right"></i>,
        next: <i className="fa fa-chevron-left"></i>,
        last: "Last",
      },
    },
  };
  return (
    <div>
      <DataTable config={config} columns={columns} data={props.data} />
    </div>
  );
}

export default DataGridFiles;
